<div class="body" [formGroup]="formGroup">

    <mat-form-field class="width" [appearance]="appearance">
        <mat-label>Bezeichnung</mat-label>
        <input formControlName="filtertext" placeholder="z.B. Aktive Verträge" matInput />
        <button matSuffix mat-icon-button color="warn" [disabled]="!filtertextControl.value" (click)="filtertextControl.setValue(null)">
            <mat-icon>clear</mat-icon>
        </button>
    </mat-form-field>

    <mat-form-field class="width" [appearance]="appearance">
        <mat-label>Suchtyp wählen</mat-label>
        <mat-select formControlName="filtertype">
            <mat-option *ngFor="let type of FilterTypes" [value]="type.value">
                {{type.title}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="width" [appearance]="appearance">
        <mat-label>Beschreibung</mat-label>
        <textarea formControlName="filterdesc" placeholder="z.B. ausschließlich aktive Verträge" matInput></textarea>
    </mat-form-field>

    <div class="sort-selection-container">

        <mat-form-field class="width" [appearance]="appearance">
            <mat-label>Sortierung ({{filtersortdscControl.value? 'Absteigend': 'Aufsteigend'}})</mat-label>
            <mat-select formControlName="filtersortattribute">

                <ng-container *ngIf="currentFilterType">

                    <mat-option *ngFor="let criteria of currentFilterType.criteria" [value]="criteria.value">
                        {{criteria.title}}
                    </mat-option>

                </ng-container>

            </mat-select>
        </mat-form-field>

        <div class="toggle">
            <mat-slide-toggle formControlName="filtersortdsc"></mat-slide-toggle>
        </div>

    </div>

    <div class="headline">
        Darstellung
    </div>

    <div class="icon-preview-container">

        <div class="icon-preview" [style.backgroundColor]="filterbackgroundcolorControl.value"
        [style.color]="filtercolorControl.value">
            <mat-icon class="icon">{{filtericonControl.value}}</mat-icon>
        </div>

        <div class="controls">

            <app-select-icon-component 
                [appearance]="appearance"
                [preSelected]="filtericonControl.value"
                (selectionChanged)="filtericonControl.setValue($event)"
            ></app-select-icon-component>

            <mat-form-field class="width" [appearance]="appearance">
                <mat-label>Schriftfarbe</mat-label>
                <input formControlName="filtercolor" [colorPicker]="filtercolorControl.value"
                    (colorPickerChange)="filtercolorControl.setValue($event)" matInput readonly />
            </mat-form-field>

            <mat-form-field class="width" [appearance]="appearance">
                <mat-label>Hintergrundfarbe</mat-label>
                <input formControlName="filterbackgroundcolor" [colorPicker]="filterbackgroundcolorControl.value"
                    (colorPickerChange)="filterbackgroundcolorControl.setValue($event)" matInput readonly />
            </mat-form-field>

        </div>
    </div>

    <div class="headline">
        Weitere Optionen
    </div>

    <div *ngIf="filterObjectControl.value" class="option" (click)="deleteFilterCondition()">
        Kriterien löschen
    </div>

    <div class="option" (click)="deleteFilter()">
        Filter löschen
    </div>

</div>